export * from './http-client.service'
export * from './types'

export * from './__mocks/http-client.service-mock'



// WEBPACK FOOTER //
// ./src/modules/http-client/index.ts